/**
 * ค่ายทางโคมเหล็ก: the lantern guard drilling in ranks. Martial and disciplined — marching
 * drums and clappers, a pipa riff, the zheng's accented tune, a small gong to call the step.
 */
import { arp, drone } from '../compose';
import { registerTrack } from '../registry';

const RIFF = `5,_ 5,_ 1_ 5,_ 2_ 5,_ 1_ 6,_`;
const A_ZHENG = `@f 5!. 6_ 5 3 | 2_ 3_ 5_ 6_ 5\\- | 1'!. 6_ 5 6 | 5- 0 5_ 5_ |
  6!. 1'_ 6 5 | 3_ 5_ 6_ 1'_ 2'^- | 1'_ 6_ 5_ 3_ 2 3 | 5g-- 0`;
const ROOTS_A = `5,, 5,, 1, 5,, 6,, 2, 5,, 5,,`;
const MARCH = `D_ 0_ d_ d_ D_ 0_ d_ t_`;
const DRUMS_A = [`g&D_ 0_ d_ d_ D_ 0_ d_ t_`, MARCH, MARCH, `D_ 0_ d_ d_ D D`, `g&D_ 0_ d_ d_ D_ 0_ d_ t_`, MARCH, MARCH, `D_ 0_ d_ d_ D D`].join(' | ');

const B_PIPA = `@f 6%- 5 3 | 2_ 3_ 2_ 1_ 6,- | 1%- 2 3 | 5%--- |
  6. 5_ 3 5 | 6_ 1'_ 6_ 5_ 3- | 2_ 3_ 5_ 3_ 2 1 | 5,%---`;
const ROOTS_B = `6,, 6,, 1, 5,, 6,, 6,, 2, 5,,`;
const DRUMS_B = Array(8).fill(`D_ 0_ t_ 0_ d_ d_ t_ 0_`).join(' | ');

registerTrack({
  id: 'lantern-road',
  order: 8,
  title: 'แถวทัพตะเกียงเหล็ก',
  mood: 'ฮึกเหิม มีวินัย ทหาร',
  use: 'ค่ายทางโคมเหล็ก (ทางโคมเหล็ก)',
  key: 'G',
  mode: 'zhi',
  bpm: 108,
  meter: 4,
  seed: 808,
  humanize: 0.25,
  parts: {
    zheng: { inst: 'zheng', pan: 0.15, reverb: 0.25 },
    pipa: { inst: 'pipa', gain: 0.85, pan: -0.2, reverb: 0.2 },
    comp: { inst: 'zheng', gain: 0.42, pan: -0.3, reverb: 0.2 },
    pad: { inst: 'pad', gain: 0.6, reverb: 0.3 },
    drums: { inst: 'perc', gain: 0.42, reverb: 0.2 },
  },
  sections: {
    A: {
      bars: 8,
      parts: {
        zheng: A_ZHENG,
        pipa: `@mp ${Array(8).fill(RIFF).join(' | ')}`,
        pad: drone(ROOTS_A, 4),
        drums: DRUMS_A,
      },
    },
    B: {
      bars: 8,
      parts: {
        pipa: B_PIPA,
        comp: arp(ROOTS_B, [null, 3, null, 5, null, 3, null, 5]),
        pad: drone(ROOTS_B, 4),
        drums: DRUMS_B,
      },
    },
    C: {
      bars: 4,
      parts: {
        zheng: `0--- | 0--- | 0--- | 0- 1'g-`,
        pipa: `@f 5,%--- | 6,%--- | 1%--- | 2%- 5!-`,
        drums: `G--- | D_ D_ d_ d_ D d | D_ D_ d_ d_ D d | D! D! D! D!`,
      },
    },
  },
  form: ['A', 'B', 'A', 'C', 'B', 'A'],
  loop: true,
});
